
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref9f1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref9f1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("6l0nW", function(module, exports) {

$parcel$export(module.exports, "MODEL_URL", () => $49d500b8b6ab9673$export$da3ae286263853d);
$parcel$export(module.exports, "MEDIAPIPE_WASM", () => $49d500b8b6ab9673$export$7e460f8658389e39);
$parcel$export(module.exports, "MESSAGE_CODE", () => $49d500b8b6ab9673$export$a9a88ff646b2e4e0);
$parcel$export(module.exports, "MODEL_STATUS", () => $49d500b8b6ab9673$export$db432458c418d88a);
/**
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $49d500b8b6ab9673$export$da3ae286263853d = "https://storage.googleapis.com/jmstore/kaggleweb/grader/g-2b-it-gpu-int4.bin";
const $49d500b8b6ab9673$export$7e460f8658389e39 = "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-genai/wasm";
const $49d500b8b6ab9673$export$a9a88ff646b2e4e0 = {
    PREPARING_MODEL: "preparing-model",
    MODEL_READY: "model-ready",
    GENERATING_RESPONSE: "generating-response",
    RESPONSE_READY: "response-ready",
    MODEL_ERROR: "model-error",
    INFERENCE_ERROR: "inference-error"
};
const $49d500b8b6ab9673$export$db432458c418d88a = {
    NOT_STARTED: "not-started",
    PREPARING: "preparing",
    READY: "ready",
    GENERATING: "generating-response",
    ERROR: "error"
};

});

var $114b06f9e0ea1c84$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["kb9mm","index.1fa6e2dc.js","4XB3H","worker.6109b960.js"]'));

/**
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $6l0nW = parcelRequire("6l0nW");
/**
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // How long to wait after the user stops typing until we trigger the AI inference
const $bebe1cbb5a309c8c$export$78dcc11c689ef8f0 = 800;


var $68af96198b9ee0ed$exports = {};
$68af96198b9ee0ed$exports = new URL("worker.6109b960.js", import.meta.url).toString();


const $b63be9b0371e788c$var$url = new URL($68af96198b9ee0ed$exports);
// Initialization
let $b63be9b0371e788c$var$modelStatus = (0, $6l0nW.MODEL_STATUS).NOT_STARTED;
$b63be9b0371e788c$var$displayModelStatus($b63be9b0371e788c$var$modelStatus);
$b63be9b0371e788c$var$displayReviewHelperOutput("No tip yet to improve your review.");
const $b63be9b0371e788c$var$worker = new Worker($b63be9b0371e788c$var$url);
let $b63be9b0371e788c$var$typingTimeout = 0;
// DOM manipulation, display and events
function $b63be9b0371e788c$var$handleUserInputChange(event) {
    if ($b63be9b0371e788c$var$typingTimeout) clearTimeout($b63be9b0371e788c$var$typingTimeout);
    $b63be9b0371e788c$var$typingTimeout = setTimeout(()=>{
        console.info("Input: User has stopped typing");
        if ($b63be9b0371e788c$var$modelStatus === (0, $6l0nW.MODEL_STATUS).READY) {
            console.info("Trigger inference");
            $b63be9b0371e788c$var$runLLMInference();
        }
        setTimeout(()=>{}, 1000);
    }, (0, $bebe1cbb5a309c8c$export$78dcc11c689ef8f0)); // 800ms delay
}
function $b63be9b0371e788c$var$updateUiByModelStatus(status) {
    $b63be9b0371e788c$var$displayModelStatus(status);
    $b63be9b0371e788c$var$displayReviewHelperStatus(status);
    $b63be9b0371e788c$var$displayAiEffectStatus(status);
}
function $b63be9b0371e788c$var$displayAiEffectStatus(status) {
    document.getElementById("aiEffect").className = status;
}
function $b63be9b0371e788c$var$displayModelStatus(status) {
    document.getElementById("modelStatusWrapper").className = status;
    document.getElementById("modelStatus").className = status;
}
function $b63be9b0371e788c$var$displayReviewHelperStatus(status) {
    document.getElementById("reviewHelperStatusWrapper").className = status;
    document.getElementById("reviewHelperStatus").className = status;
}
function $b63be9b0371e788c$var$displayReviewHelperOutput(output) {
    $b63be9b0371e788c$var$resetScrollReviewHelperBubble();
    document.getElementById("reviewHelperOutput").innerText = output;
}
function $b63be9b0371e788c$var$simulatePostReview() {
    document.getElementById("reviewInputEl").value = "";
    window.alert("Review posted!");
}
function $b63be9b0371e788c$var$resetScrollReviewHelperBubble() {
    const reviewHelperOutputEl = document.getElementById("reviewHelperOutput");
    reviewHelperOutputEl.scrollTop = 0;
}
function $b63be9b0371e788c$var$toggleReviewHelperBubble() {
    $b63be9b0371e788c$var$resetScrollReviewHelperBubble();
    document.getElementById("reviewHelperBubble").classList.toggle("hidden");
}
// Gen AI / inference + worker message handling
function $b63be9b0371e788c$var$runLLMInference() {
    // TODO manage empty input
    const userPrompt = document.getElementById("reviewInputEl").value.trim();
    $b63be9b0371e788c$var$worker.postMessage(userPrompt);
}
$b63be9b0371e788c$var$worker.onmessage = function(message) {
    console.info("[Main thread] \uD83D\uDCEC Message from worker: ", message);
    if (!message.data || !message.data.code) throw new Error(`Message from worker is empty or doesn't contain a code field: ${message}`);
    const messageCode = message.data.code;
    switch(messageCode){
        case (0, $6l0nW.MESSAGE_CODE).PREPARING_MODEL:
            $b63be9b0371e788c$var$modelStatus = (0, $6l0nW.MODEL_STATUS).PREPARING;
            $b63be9b0371e788c$var$updateUiByModelStatus($b63be9b0371e788c$var$modelStatus);
            break;
        case (0, $6l0nW.MESSAGE_CODE).MODEL_READY:
            $b63be9b0371e788c$var$modelStatus = (0, $6l0nW.MODEL_STATUS).READY;
            $b63be9b0371e788c$var$updateUiByModelStatus($b63be9b0371e788c$var$modelStatus);
            $b63be9b0371e788c$var$runLLMInference();
            break;
        case (0, $6l0nW.MESSAGE_CODE).GENERATING_RESPONSE:
            $b63be9b0371e788c$var$modelStatus = (0, $6l0nW.MODEL_STATUS).GENERATING;
            $b63be9b0371e788c$var$updateUiByModelStatus($b63be9b0371e788c$var$modelStatus);
            $b63be9b0371e788c$var$displayReviewHelperOutput("Thinking...");
            break;
        case (0, $6l0nW.MESSAGE_CODE).RESPONSE_READY:
            // TODO change to "ready again" to diff from first-time READY state?
            $b63be9b0371e788c$var$modelStatus = (0, $6l0nW.MODEL_STATUS).READY;
            $b63be9b0371e788c$var$updateUiByModelStatus($b63be9b0371e788c$var$modelStatus);
            $b63be9b0371e788c$var$displayReviewHelperOutput(message.data.payload);
            break;
        case (0, $6l0nW.MESSAGE_CODE).MODEL_ERROR:
            $b63be9b0371e788c$var$modelStatus = (0, $6l0nW.MODEL_STATUS).ERROR;
            $b63be9b0371e788c$var$updateUiByModelStatus($b63be9b0371e788c$var$modelStatus);
            break;
        case (0, $6l0nW.MESSAGE_CODE).INFERENCE_ERROR:
            $b63be9b0371e788c$var$modelStatus = (0, $6l0nW.MODEL_STATUS).ERROR;
            $b63be9b0371e788c$var$updateUiByModelStatus($b63be9b0371e788c$var$modelStatus);
            $b63be9b0371e788c$var$displayReviewHelperOutput("No suggestion");
            break;
        default:
            throw new Error(`Message from worker contains an unknown message code: ${messageCode}`);
    }
};
window.runLLMInference = $b63be9b0371e788c$var$runLLMInference;
window.simulatePostReview = $b63be9b0371e788c$var$simulatePostReview;
window.handleUserInputChange = $b63be9b0371e788c$var$handleUserInputChange;
window.toggleReviewHelperBubble = $b63be9b0371e788c$var$toggleReviewHelperBubble;


//# sourceMappingURL=index.1fa6e2dc.js.map
